import { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { LoadingComponent } from '../../components/global/LoadingComponent';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary';

const PdpRespZoomModalLazy = lazy(() =>
    import(
        /* webpackChunkName: "PdpRespZoomModalWrapper" */
        './PdpRespZoomModalWrapper'
    ).then(PdpRespZoomModal => ({ default: PdpRespZoomModal.PdpRespZoomModalWrapper }))
);

export function PdpRespZoomModalLoader(props) {
    if (!props.isOpen) {
        return null;
    }
    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense fallback={<LoadingComponent />}>
                <PdpRespZoomModalLazy {...props} />
            </Suspense>
        </ErrorBoundary>
    );
}

PdpRespZoomModalLoader.propTypes = {
    isOpen: PropTypes.bool.isRequired,
};
